import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '@haleo-frontend/data-access/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UnAuthGuard implements CanActivate {

    constructor(private authService: AuthService,
                private router: Router) {

    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        return this.authService.isAuthenticated()
            .pipe(map(isAuthenticated => {

                if (isAuthenticated) {
                    this.router.navigate([next.data.authRoute]);
                    return false;
                }

                return true;
            }));
    }
}
